import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { XingFrameConsumer } from '@xingternal/xing-frame-provider';

export const featureSwitchesTypes = {
  and: 'and',
  either: 'either',
};

const switchesArray = switches =>
  Array.isArray(switches) ? switches : [switches];

// All selected switches must match
export const matchAll = allSwitches => selectedSwitches => {
  const all = switchesArray(allSwitches);
  return (
    all.filter(s => selectedSwitches.includes(s)).length ===
    selectedSwitches.length
  );
};

// At least one selected switch must match
export const matchAny = allSwitches => selectedSwitches => {
  const all = switchesArray(allSwitches);
  return all.filter(s => selectedSwitches.includes(s)).length > 0;
};

export const FeatureSwitch = ({
  children,
  flags = [],
  elseCase = null,
  matchMode,
}) => (
  <XingFrameConsumer>
    {({ featureSwitches }) => {
      const matcher =
        matchMode === featureSwitchesTypes.and ? matchAll : matchAny;

      return matcher(featureSwitches)(flags) ? (
        <Fragment>{children}</Fragment>
      ) : (
        <Fragment>{elseCase}</Fragment>
      );
    }}
  </XingFrameConsumer>
);

FeatureSwitch.defaultProps = {
  matchMode: featureSwitchesTypes.either,
};

FeatureSwitch.propTypes = {
  children: PropTypes.node.isRequired,
  flags: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  elseCase: PropTypes.node,
  matchMode: PropTypes.oneOf(Object.values(featureSwitchesTypes)),
};

export default FeatureSwitch;
